<div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>
<div *ngIf="showPopup" class="popup" fxLayout="column" fxFlex="40">
  <div class="popup-header" fxLayout="row" fxLayoutAlign="start start" fxFlex="6">
    <button class="back-button" (click)="closePopup()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <!-- <form>
      <label for="search">Search</label>
      <input id="search" type="search" pattern=".*\S.*" required>
      <span class="caret"></span>
    </form> -->
  </div>
  <div class="popup-content" fxLayout="row" fxFlex="auto">
    <div class="scrollspy" fxFlex="30">
      <ul>
        <li *ngFor="let section of sections" [class.active]="activeSection === section.id"
          (click)="selectSection(section.id)">
          {{ section.name }}
        </li>
      </ul>
    </div>
    <div class="section-content" fxFlex="80">
      <ng-container *ngFor="let section of sections" [ngSwitch]="section.id" id="{{ section.id }}"
        [class.hidden]="activeSection !== section.id">
        <div *ngSwitchCase="'dimensions'" id="dimensions">
          <h2 class="sec-name">{{ section.name }}</h2>
          <div *ngFor="let row of section.rows">
            <div class="row">
              <div class="title">{{ row.title }}</div>
              <div class="value">{{ row.value }}</div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'engine'" id="engine">
          <h2>{{ section.name }}</h2>
          <div *ngFor="let row of section.rows">
            <div class="row">
              <div class="title">{{ row.title }}</div>
              <div class="value">{{ row.value }}</div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'fuel'" id="fuel">
          <h2>{{ section.name }}</h2>
          <div *ngFor="let row of section.rows">
            <div class="row">
              <div class="title">{{ row.title }}</div>
              <div class="value">{{ row.value }}</div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'suspension'" id="suspension">
          <h2>{{ section.name }}</h2>
          <div *ngFor="let row of section.rows">
            <div class="row">
              <div class="title">{{ row.title }}</div>
              <div class="value">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="popup-footer" fxLayout="row" fxFlex="none">
    <button mat-button class="Footer-buttons">Book Now</button>
    <button mat-button class="Footer-buttons">Free Test Drive</button>
  </div>
</div>